import { get, post } from '../../utils/http';

export const fetchPayrollProcessHistory = ({ accountId }) => get(`/accounts/${accountId}/payroll/process-history`);

export const fetchPayrollProcessDummyHistory = ({ accountId }) =>
  get(`/accounts/${accountId}/payroll/process-history/dummy`);

export const fetchReconciliationPayrollProcessHistory = ({ accountId, payrollProcessHistoryIds }) =>
  post(`/accounts/${accountId}/payroll/process-history/reconciliation`, { payrollProcessHistoryIds });

export const revertPayrollProcessHistory = ({ accountId, payrollProcessHistoryIds }) =>
  post(`/accounts/${accountId}/payroll/process-history/revert`, { payrollProcessHistoryIds });
